import multiApiClient from "./base";

export const ottoCredentialsApi = {
  // Get all credentials
  getCredentials: () => multiApiClient.get("/otto/credentials/"),

  // Create new credential
  createCredential: (credential) =>
    multiApiClient.post("/otto/credentials/", credential),
  // Update credential
  updateCredential: (id, credential) =>
    multiApiClient.put(`/otto/credentials/${id}`, credential),

  // Delete credential
  deleteCredential: (id) => multiApiClient.delete(`/otto/credentials/${id}`),

  // Test credentials
  testCredentials: (credentials) =>
    multiApiClient.post("/otto/credentials/test", credentials),

  testCredentialsbyId: (id) =>
    multiApiClient.post(`/otto/credentials/${id}/test`),

  // Get credential suggestions (names)
  getCredentialNames: () => multiApiClient.get("/otto/credential_names"),

  //toogle active status
  toggleCredentialStatus: (id) =>
    multiApiClient.put(`/otto/credentials/${id}/toggle_status`),
};
